var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthCoach({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.554688,
    width: 51,
    height: 51,
    rx: 14,
    fill: "#4B4AD5",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.0559 10.625C22.1586 10.625 18.9902 13.7934 18.9902 17.6906C18.9902 21.5135 21.9801 24.6075 25.8774 24.7414C25.9963 24.7265 26.1154 24.7265 26.2046 24.7414C26.2344 24.7414 26.2493 24.7414 26.279 24.7414C26.2939 24.7414 26.2939 24.7414 26.3087 24.7414C30.1167 24.6075 33.1066 21.5135 33.1215 17.6906C33.1215 13.7934 29.9531 10.625 26.0559 10.625Z",
    fill: "#4B4AD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6106 28.7001C29.4604 25.9333 22.6922 25.9333 18.5124 28.7001C16.6233 29.9645 15.582 31.675 15.582 33.5046C15.582 35.3343 16.6233 37.03 18.4975 38.2795C20.58 39.6778 23.317 40.3769 26.054 40.3769C28.7911 40.3769 31.528 39.6778 33.6106 38.2795C35.4848 37.0152 36.526 35.3195 36.526 33.4749C36.5112 31.6453 35.4848 29.9496 33.6106 28.7001Z",
    fill: "#4B4AD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.813 32.4685H27.0895V30.745C27.0895 30.1798 26.6206 29.7109 26.0554 29.7109C25.4901 29.7109 25.0213 30.1798 25.0213 30.745V32.4685H23.2978C22.7324 32.4685 22.2637 32.9374 22.2637 33.5026C22.2637 34.068 22.7324 34.5368 23.2978 34.5368H25.0213V36.2603C25.0213 36.8256 25.4901 37.2945 26.0554 37.2945C26.6206 37.2945 27.0895 36.8256 27.0895 36.2603V34.5368H28.813C29.3784 34.5368 29.8471 34.068 29.8471 33.5026C29.8471 32.9374 29.3784 32.4685 28.813 32.4685Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCoach);
export default __webpack_public_path__ + "static/media/healthCoach.3bbdbce48247b21311235c8583524672.svg";
export { ForwardRef as ReactComponent };